import React from 'react';
import InputField from '../input/InputField';
import MultiSelectField from '../input/MultiSelectField';
import { FiSearch } from 'react-icons/fi';

const CandidateFilters = ({ filters, onFilterChange, onCityToggle, availableCities, onSearch, t }) => {
  const handleChange = (e) => onFilterChange(e.target.name, e.target.value);

  return (
    <div className="flex flex-col lg:flex-row lg:items-end gap-3 w-full">
      <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 w-full">
        <InputField
          label={t('FORM.CONTACT.NAME')}
          name="firstName"
          value={filters.firstName}
          onChange={handleChange}
          placeholder={t('FORM.CONTACT.NAME')}
        />
        <InputField
          label={t('FORM.CONTACT.JOB')}
          name="currentPosition"
          value={filters.currentPosition}
          onChange={handleChange}
          placeholder={t('FORM.CONTACT.PLACEHOLDERS.JOB')}
        />

        <MultiSelectField
          label={t('FORM.CONTACT.CITY')}
          options={availableCities}
          selectedValues={filters.city}
          onToggle={onCityToggle}
          placeholder={t('FORM.CONTACT.PLACEHOLDERS.CITY')}
        />

        <InputField
          label={t('FORM.EDUCATION.TITLE')}
          name="degreeTitle"
          value={filters.degreeTitle}
          onChange={handleChange}
          placeholder={t('FORM.EDUCATION.TITLE')}
        />
      </div>

      <button
        onClick={onSearch}
        className="h-10 w-full lg:w-auto px-6 bg-secondary text-darkGray rounded-xl flex items-center justify-center hover:brightness-95 font-semibold"
      >
        <FiSearch size={18} />
        <span className="text-sm lg:hidden xl:inline">{t('FILTER.SEARCH')}</span>
      </button>
    </div>
  );
};

export default CandidateFilters;